import { FormDataKey } from "src/types";

export class ValidationError<T extends FormDataKey> extends Error {
  readonly formDataKey: T;
  readonly reference?: string;

  constructor(message: string, formDataKey: T) {
    super(message);
    this.name = "ValidationError";
    this.formDataKey = formDataKey;
  }
}
